export interface Crumb {
  label: string;
  href?: string;
}

interface CrumbClient {
  id: string;
  name?: string;
}

const SECTION_LABELS: Record<string, string> = {
  dashboard: "Dashboard",
  clients: "Clients",
  billing: "Billing",
  activity: "Activity",
  infrastructure: "Infrastructure",
  settings: "Settings",
};

// Route-driven breadcrumbs. Stops at the entity/section — sub-tabs (e.g. a
// client's Design tab, or Database Backup) are conveyed by the in-page tabs,
// not the breadcrumb. Pure so it can be unit-tested without a router.
export function deriveCrumbs(pathname: string, clients: CrumbClient[] = []): Crumb[] {
  const segments = pathname.split("/").filter(Boolean);
  if (segments.length === 0) return [{ label: "Dashboard" }];

  const [section, sub] = segments;

  if (section === "clients") {
    if (!sub) return [{ label: "Clients" }];
    if (sub === "new") {
      return [{ label: "Clients", href: "/clients" }, { label: "New client" }];
    }
    const client = clients.find((c) => c.id === sub);
    return [
      { label: "Clients", href: "/clients" },
      { label: client?.name ?? sub },
    ];
  }

  const label =
    SECTION_LABELS[section] ?? section.charAt(0).toUpperCase() + section.slice(1);
  return [{ label }];
}
